import React,{Component} from 'react'

class Clock extends Component {
	
	componentDidMount(){
		this.handleTimer();
		// console.log('clock mount')
		
	}
	
    render(){
        return (
            <div className="clock d-inline mx-3" id="clock"  style={{textShadow:'none'}}>
            
            </div>
        )
	}

	handleTimer(){
		var days, hours, minutes, seconds=0;
		// Set the date we're counting down to
		var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
		// Update the count down every 1 second
		var x = setInterval(function() {
	
		// Get today's date and time
		var now = new Date().getTime();

		// Find the distance between now and the count down date
		var distance = countDownDate - now;

		// Time calculations for days, hours, minutes and seconds
		var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((distance % (1000 * 60)) / 1000);
		// Display the result in the element with id="clock"
	// console.log(document.getElementById('clock'))
		document.getElementById('clock').innerHTML=days+"days " + hours + ": "+ minutes + ": " + seconds;
		
		// If the count down is finished, write some text
		if (distance < 0) {
			clearInterval(x);
			document.getElementById('clock').innerHTML= "EXPIRED";
		}
		}, 1000);
	}

		
	

    
}

export default Clock;
